import {
  canUseProductionAutomation,
} from '../../utils/productionAccess.js';
export const JIANYING_CREATE_PATH = '/automation/jianying/create';

export const canUseJianyingEntry = (role) =>
  canUseProductionAutomation(role);

export const shouldShowJianyingProductionButton = ({ role, automation } = {}) =>
  canUseJianyingEntry(role) && automation?.supported === true;

export const buildJianyingCreatePath = (orderId) => {
  const params = new URLSearchParams();
  params.set('client_id', String(orderId || ''));
  return `${JIANYING_CREATE_PATH}?${params.toString()}`;
};
